export default function About() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="animate-slide-in-left">
            <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-6 font-display">
              About Bridgend Electricians
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                <strong className="text-secondary">Bridgend Electricians</strong> is your trusted local electrical service provider, serving homes and businesses across Bridgend and the wider South Wales region. With years of experience and a commitment to excellence, we deliver professional electrical solutions that prioritize safety, quality, and customer satisfaction.
              </p>
              <p>
                Our team of <strong className="text-secondary">NAPIT approved electricians</strong> holds the latest 18th Edition certifications and is fully insured for all types of electrical work. From simple repairs to complete rewiring projects, we handle every job with the same level of professionalism and attention to detail.
              </p>
              <p>
                We understand that electrical emergencies don't follow a schedule, which is why we offer a <strong className="text-secondary">24/7 emergency callout service</strong> throughout Bridgend and surrounding areas. Whether you're experiencing a power outage, tripping circuits, or any other urgent electrical issue, our team is ready to respond quickly and efficiently.
              </p>
              <p>
                What sets us apart is our dedication to transparent pricing, reliable service, and exceptional workmanship. We provide free, no-obligation quotes for all projects and ensure that every installation and repair meets the highest industry standards. Our 5-star Google reviews speak to our commitment to customer satisfaction.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-md">
                <div className="text-4xl font-bold text-primary mb-2">10+</div>
                <div className="text-sm text-gray-600 font-semibold">Years Experience</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md">
                <div className="text-4xl font-bold text-primary mb-2">500+</div>
                <div className="text-sm text-gray-600 font-semibold">Projects Completed</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md">
                <div className="text-4xl font-bold text-primary mb-2">5.0</div>
                <div className="text-sm text-gray-600 font-semibold">Google Rating</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md">
                <div className="text-4xl font-bold text-primary mb-2">24/7</div>
                <div className="text-sm text-gray-600 font-semibold">Emergency Service</div>
              </div>
            </div>
          </div>

          <div className="animate-slide-in-right">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="w-full h-48 rounded-xl overflow-hidden shadow-lg">
                  <img
                    src="https://i.ibb.co/0yrrxC01/IMG-3593.jpg"
                    alt="Professional electrical work"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-64 rounded-xl overflow-hidden shadow-lg">
                  <img
                    src="https://i.ibb.co/nNZt09qN/IMG-4098-1.jpg"
                    alt="Consumer unit installation"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="w-full h-64 rounded-xl overflow-hidden shadow-lg">
                  <img
                    src="https://i.ibb.co/Zp921bjT/IMG-3702.jpg"
                    alt="Lighting installation"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-48 rounded-xl overflow-hidden shadow-lg">
                  <img
                    src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/f6f6ecc724df73d45b7fa5131c75cbcc.jpeg"
                    alt="Bridgend Electricians van"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="mt-8 bg-primary/10 border border-primary/20 rounded-xl p-6">
              <h4 className="text-xl font-bold text-secondary mb-3 font-display">
                Why Choose Us?
              </h4>
              <ul className="space-y-2">
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-double-line text-primary text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm">NAPIT approved and fully certified electricians</span>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-double-line text-primary text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm">Transparent pricing with free quotes</span>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-double-line text-primary text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm">24/7 emergency callout service</span>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-double-line text-primary text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm">5-star rated on Google</span>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-double-line text-primary text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                  <span className="text-sm">Fully insured for your peace of mind</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
